import Revealer from '../modules/Revealer';
import '../../styles/pages/_about.scss';
import '../../styles/components/_location-preview.scss';
const startPageAbout = () => {
    console.log('UNTUCKit : Template : PageAbout');
    Revealer.init();
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPageAbout, { once: true });
}
else {
    startPageAbout();
}
